/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAuthorsIdQueryResponse, GetApiAuthorsIdPathParams, GetApiAuthorsId400, GetApiAuthorsId401, GetApiAuthorsId403, GetApiAuthorsId404, GetApiAuthorsId500 } from "../../types/GetApiAuthorsId.ts";
import { getApiAuthorsIdQueryResponseSchema } from "../../zod/AuthorSchemas/getApiAuthorsIdSchema.ts";

function getGetApiAuthorsIdUrl({ id }: { id: GetApiAuthorsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/authors/${id}` as const }  
  return res
}

/**
 * @summary Метод получения автора по идентификатору.
 * {@link /api/authors/:Id}
 */
export async function getApiAuthorsId({ id }: { id: GetApiAuthorsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAuthorsIdQueryResponse, ResponseErrorConfig<GetApiAuthorsId400 | GetApiAuthorsId401 | GetApiAuthorsId403 | GetApiAuthorsId404 | GetApiAuthorsId500>, unknown>({ method : "GET", url : getGetApiAuthorsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiAuthorsIdQueryResponseSchema.parse(res.data)
}